import { CURRENCIES } from '@savgroup-front-common/constants';

import { AddressInfoDto } from './AddressInfo';
import { TopicType } from './TopicType';

export type SellerId = string;
export type TenantId = string;

export enum CONSOLE_MODE {
  NOT_SET = 'NotSet',
  SIMPLE = 'Simple',
  EXPERT = 'Expert',
}

export enum REQUIRED_ONBOARDING_CONFIG_STEP {
  NONE = 'None',
  FROM_SCRATCH_INTEGRATION = 'FromScratchIntegration',
  FROM_SCRATCH_WARRANTIES = 'FromScratchWarranties',
  FROM_SCRATCH_CARRIER_INTEGRATION = 'FromScratchCarrierIntegration',
  FROM_SCRATCH_PRICING_INTEGRATION = 'FromScratchPricingIntegration',
  FROM_SCRATCH_ACTOR = 'FromScratchActor',
  SELECT_PRICING_PLAN = 'SelectPricingPlan',
  PAYMENT_METHOD = 'PaymentMethod',
}

export enum SELLER_PRODUCT_USAGE_CONTEXT {
  PRODUCTION = 'Production',
  PRODUCT_TESTING = 'ProductTesting',
}

export enum SELLER_TYPE {
  RETAILER = 'Retailer',
  SUPPLIER = 'Supplier',
  REPAIRER = 'Repairer',
}

export enum PRICING_PLAN {
  ENTERPRISE = 'Enterprise',
  NONE = 'None',
  BASIC = 'Basic',
  ADVANCED = 'Advanced',
  FREEMIUM = 'Freemium',
}

export enum PRICING_PLAN_STATE {
  INACTIVE = 'Inactive',
  ACTIVE = 'Active',
  WAITING_FOR_PAYMENT_METHOD = 'WaitingForPaymentMethod',
  INVALID_PAYMENT_METHOD = 'InvalidPaymentMethod',
  CHURN = 'Churn',
}

export interface Seller {
  name: string;
  shortName?: string;
  id: SellerId;
  tenantId: TenantId;
  isTenant: boolean;
  addressInfos: AddressInfoDto[];
  creationDate: string;
  acceptedLanguages: string[];
  createNewQuotationFromPartnerManager?: boolean;
  cumulIntegrationId?: string;
  isSelfcareNewDesign?: boolean;
  pricingPlan?: PRICING_PLAN;
  pricingPlanState?: PRICING_PLAN_STATE;
  allowNewFiles?: boolean;
  email?: string;
  isSelfOnboardingDemoContext?: boolean;
  sellerType: SELLER_TYPE;
  sellerProductUsageContext?: SELLER_PRODUCT_USAGE_CONTEXT;
  requiredOnboardingConfigStep?: REQUIRED_ONBOARDING_CONFIG_STEP;
  billingSellerId?: string;
  workflowFeatures?: string[];
  templateSellerId?: string;
  templateTenantId?: string;
  signatureDate?: string;
  selfOnboardingDemoContextExpirationDate?: string;
  consoleMode?: CONSOLE_MODE;
  currency: CURRENCIES;
}

export interface SellerExport {
  date: string;
  id: string;
  marketplace: string;
  sellerId: string;
}

export interface ServiceBusConfiguration {
  id?: string;
  topicType: TopicType;
  topicName?: string;
  subscriptionName?: string;
  isActive?: boolean;
}

export interface NewServiceBus {
  id: string;
  sellerId: string;
  topicType: string;
  topicName: string;
  subscriptionName: string;
  isActive: boolean;
  topicUrl: string;
  primaryKey: string;
  secondaryKey: string;
  primaryConnectionString: string;
  secondaryConnectionString: string;
}

export interface AdapterConfiguration {
  id?: string;
  sellerId: string;
  adapterRequest: string;
  adapterAuthentification: string;
  verb: string;
  url: string;
}
